import Logging from '~app/core/logging';

const log = Logging.getLogger('app.actions.error');

export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const CLEAR_GLOBAL_ERROR = 'CLEAR_GLOBAL_ERROR';

export function setGlobalError(error, sourceAction) {
  log.error(`caught error=${error} while processing action=${JSON.stringify(sourceAction)}`);
  return {
    type: SET_GLOBAL_ERROR,
    error,
    sourceAction,
  };
}

export function clearGlobalError(error) {
  return {
    type: CLEAR_GLOBAL_ERROR,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/actions/error.js